import { VraagboomAntwoord, VraagboomUploadResultaat, Uploadfile } from '@models/vragenboom';
import { VariableContent, Antwoord, Vraag, VraagMail, AntwoordMail } from '@models/claims';

export class BlobMapper {
  public static mapResultaten(vraagboomAntwoord:
    VraagboomAntwoord<VraagboomUploadResultaat>, variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || variabeleContent == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;
      vragen.push(vraag);
    }

    if (vraagboomAntwoord.resultaat != null && vraagboomAntwoord.antwoorden != null) {
      let index = 0;
      for (const file of vraagboomAntwoord.resultaat.uploadedFiles) {
        if (index >= vraagboomAntwoord.antwoorden.length) {
          break;
        }

        const antwoord: Antwoord = new Antwoord({ id: vraagboomAntwoord.antwoorden[index].id });

        vraag.antwoorden.push(antwoord);

        const extensionsIndex = file.name.lastIndexOf('.');
        let name, extension = '';
        if (extensionsIndex >= 0) {
          name = file.name.substring(0, extensionsIndex);
          extension = file.name.substring(extensionsIndex + 1).toUpperCase();
        } else {
          name = file.name;
          extension = file.type;
        }

        variabeleContent.push(new VariableContent(vraag.id, antwoord.id, 'BLOBDATA', file.blob));
        variabeleContent.push(new VariableContent(vraag.id, antwoord.id, 'EXTENSIE', extension));
        variabeleContent.push(new VariableContent(vraag.id, antwoord.id, 'BESTANDSNAAM', name));
        index++;
      }
    }
  }

  public static mapResultatenMail(vraagboomAntwoord: VraagboomAntwoord<VraagboomUploadResultaat>, vragen: VraagMail[]) {
    if (vraagboomAntwoord == null || vragen == null) {
      return;
    }

    const vraag: VraagMail = new VraagMail();
    if (vraagboomAntwoord.vraag != null) {
      vraag.vraagtitel = vraagboomAntwoord.vraag.titel;
    }

    if (vraagboomAntwoord.resultaat != null && vraagboomAntwoord.antwoorden != null) {
      let index = 0;
      for (const file of vraagboomAntwoord.resultaat.uploadedFiles) {
        if (index >= vraagboomAntwoord.antwoorden.length) {
          break;
        }
        vraag.antwoorden.push(new AntwoordMail({
          antwoordtitel: file.name, antwoordFile: file.blob, antwoordFileType: file.type
        }));

        index++;
      }
    }
    vragen.push(vraag);
  }
}
